import PATHS from 'src/paths';
import {getTitleForPath} from 'src/utils';

export default {
  loading: 'Загрузка...',
  [PATHS.HOME]: 'Главная',
  [PATHS.UNAVAILABLE]: 'Сервис временно недоступен',
  [PATHS.SIGN_IN]: 'Вход в аккаунт',
  [PATHS.SIGN_UP]: 'Регистрация аккаунта',
  [getTitleForPath(PATHS.SIGN_UP_FROM_AGENT)]: 'Регистрация аккаунта',
  [PATHS.PASSWORD_SAVED]: 'Пароль сохранен!',
  [getTitleForPath(PATHS.PUBLIC_WHATSAPP_REGISTRATION)]: 'Регистрация канала WhatsApp',
  [getTitleForPath(PATHS.PUBLIC_WHATSAPP_BUSINESS_APP_REGISTRATION)]:
    'Регистрация канала WhatsApp Business App',
  [getTitleForPath(PATHS.PUBLIC_MAX_REGISTRATION)]: 'Регистрация канала MAX',
  [getTitleForPath(PATHS.PUBLIC_TELEGRAM_REGISTRATION)]: 'Регистрация канала Telegram',
  [getTitleForPath(PATHS.SIGN_IN_TENANT_BY_INVITE)]: 'Вход',
  [getTitleForPath(PATHS.SIGN_IN_USER_BY_INVITE)]: 'Вход',
  [PATHS.EMAIL_CONFIRM]: 'Email подтверждение',
  [PATHS.CHANNELS]: 'Каналы',
  [PATHS.CHANNELS_VERIFICATION_NEW]: 'Запрос верификации',
  [getTitleForPath(PATHS.CHANNELS_VERIFICATION_EDIT)]: 'Запрос верификации',
  [getTitleForPath(PATHS.CHANNELS_VERIFICATION_VIEW)]: 'Запрос верификации',
  [PATHS.MESSAGE_MATCHERS]: 'Шаблоны',
  [getTitleForPath(PATHS.SUPPORT_MESSAGE_MATCHERS_LIST)]: 'Шаблоны',
  [getTitleForPath(PATHS.SUPPORT_MESSAGE_MATCHER_VIEW)]: 'Просмотр шаблона',
  [PATHS.CHANNELS_WHATSAPP_NEW]: 'Создание канала WhatsApp',
  [getTitleForPath(PATHS.CHANNELS_WHATSAPP_EDIT)]: 'Редактирование канала WhatsApp',
  [getTitleForPath(PATHS.CHANNELS_WHATSAPP_VIEW)]: 'Просмотр канала WhatsApp{{postfix}}',
  [PATHS.CHANNELS_WHATSAPP_TECH_PARTNER_NEW]: 'Создание канала WhatsApp',
  [getTitleForPath(PATHS.CHANNELS_WHATSAPP_TECH_PARTNER_EDIT)]:
    'Редактирование канала WhatsApp{{postfix}}',
  [getTitleForPath(PATHS.CHANNELS_WHATSAPP_TECH_PARTNER_VIEW)]:
    'Просмотр канала WhatsApp{{postfix}}',
  [PATHS.CHANNELS_WHATSAPP_BUSINESS_APP_TECH_PARTNER_NEW]: 'Создание канала WhatsApp Business App',
  [PATHS.CHANNELS_WHATSAPP_BUSINESS_APP_NEW]: 'Создание канала WhatsApp Business App',
  [getTitleForPath(PATHS.CHANNELS_WHATSAPP_BUSINESS_APP_EDIT)]:
    'Редактирование канала WhatsApp Business App',
  [PATHS.CHANNELS_VIBER_NEW]: 'Создание канала Viber',
  [getTitleForPath(PATHS.CHANNELS_VIBER_EDIT)]: 'Редактирование канала Viber',
  [getTitleForPath(PATHS.CHANNELS_VIBER_VIEW)]: 'Просмотр канала Viber',
  [PATHS.CHANNELS_SMS_NEW]: 'Создание канала SMS',
  [getTitleForPath(PATHS.CHANNELS_SMS_EDIT)]: 'Данные канала SMS',
  [getTitleForPath(PATHS.CHANNELS_SMS_VIEW)]: 'Данные канала SMS',
  [PATHS.CHANNELS_MAX_BOT_NEW]: 'Создание канала MAX Bot',
  [getTitleForPath(PATHS.CHANNELS_MAX_BOT_EDIT)]: 'Редактирование канала MAX Bot',
  [getTitleForPath(PATHS.CHANNELS_MAX_BOT_NEW)]: 'Просмотр канала MAX Bot',
  [PATHS.CHANNELS_MAX_NEW]: 'Создание канала MAX',
  [getTitleForPath(PATHS.CHANNELS_MAX_EDIT)]: 'Редактирование канала MAX',
  [getTitleForPath(PATHS.CHANNELS_MAX_VIEW)]: 'Просмотр канала MAX',
  [PATHS.CHANNELS_MAX_TECH_PARTNER_NEW]: 'Создание канала MAX',
  [getTitleForPath(PATHS.CHANNELS_MAX_TECH_PARTNER_EDIT)]: 'Редактирование канала MAX',
  [getTitleForPath(PATHS.CHANNELS_MAX_TECH_PARTNER_VIEW)]: 'Просмотр канала MAX',
  [PATHS.CHANNELS_TELEGRAM_NEW]: 'Создание канала Telegram',
  [getTitleForPath(PATHS.CHANNELS_TELEGRAM_EDIT)]: 'Редактирование канала Telegram',
  [getTitleForPath(PATHS.CHANNELS_TELEGRAM_VIEW)]: 'Просмотр канала Telegram',
  [PATHS.CHANNELS_TELEGRAM_TECH_PARTNER_NEW]: 'Создание канала Telegram',
  [getTitleForPath(PATHS.CHANNELS_TELEGRAM_TECH_PARTNER_EDIT)]: 'Редактирование канала Telegram',
  [getTitleForPath(PATHS.CHANNELS_TELEGRAM_TECH_PARTNER_VIEW)]: 'Просмотр канала Telegram',
  [PATHS.MESSAGE_MATCHERS_WHATSAPP_NEW]: 'Новый шаблон',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_WHATSAPP_EDIT)]: 'Редактирование шаблона WhatsApp',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_WHATSAPP_VIEW)]: 'Просмотр шаблона WhatsApp',
  [PATHS.MESSAGE_MATCHERS_VIBER_NEW]: 'Новый шаблон Viber',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_VIBER_EDIT)]: 'Редактирование шаблона Viber',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_VIBER_VIEW)]: 'Просмотр шаблона Viber',
  [PATHS.MESSAGE_MATCHERS_SMS_NEW]: 'Новый шаблон SMS',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_SMS_EDIT)]: 'Редактирование шаблона SMS',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_SMS_VIEW)]: 'Просмотр шаблона SMS',
  [PATHS.MESSAGE_MATCHERS_PUSH_NEW]: 'Новый шаблон Push',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_PUSH_EDIT)]: 'Редактирование шаблона Push',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_PUSH_VIEW)]: 'Просмотр шаблона Push',
  [PATHS.MESSAGE_MATCHERS_OK_NOTIFY_NEW]: 'Новый шаблон OK Notify',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_OK_NOTIFY_EDIT)]: 'Редактирование шаблона OK Notify',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_OK_NOTIFY_VIEW)]: 'Просмотр шаблона OK Notify',
  [PATHS.MESSAGE_MATCHERS_VK_NOTIFY_NEW]: 'Новый шаблон VK Notify',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_VK_NOTIFY_EDIT)]: 'Редактирование шаблона VK Notify',
  [getTitleForPath(PATHS.MESSAGE_MATCHERS_VK_NOTIFY_VIEW)]: 'Просмотр шаблона VK Notify',
  [PATHS.BROADCASTS_LIST]: 'Рассылки',
  [getTitleForPath(PATHS.BROADCASTS_DETAILS)]: 'Детали рассылки',
  [PATHS.BROADCASTS_NEW]: 'Создание рассылки',
  [getTitleForPath(PATHS.BROADCASTS_EDIT)]: 'Редактирование рассылки',
  [PATHS.CASCADES_LIST]: 'Каскады',
  [PATHS.CASCADES_NEW]: 'Создание каскада',
  [getTitleForPath(PATHS.CASCADES_VIEW)]: 'Просмотр каскада',
  [PATHS.SUBSCRIBERS_LIST]: 'Аудитория',
  [PATHS.SUBSCRIBERS_NEW]: 'Добавить получателя',
  [getTitleForPath(PATHS.SUBSCRIBERS_EDIT)]: 'Редактирование получателя',
  [PATHS.SUBSCRIBERS_GROUP_EDIT]: 'Добавление списка получателей',
  [PATHS.PROFILE]: 'Мой профиль',
  [PATHS.COMPANY_PROFILE]: 'Профиль {{companyName}}',
  [getTitleForPath(PATHS.NEWS)]: 'Новости компании',
  [PATHS.COMPANY_CLIENTS]: 'Лиды',
  [getTitleForPath(PATHS.COMPANY_CLIENT_CARD)]: 'Карточка лида',
  [getTitleForPath(PATHS.COMPANY_CLIENT_NEW)]: 'Создать лид',
  [getTitleForPath(PATHS.COMPANY_CLIENT_EDIT)]: 'Создать лид',
  [PATHS.COMPANY_AGENT_CLIENTS]: 'Агенты',
  [getTitleForPath(PATHS.COMPANY_AGENT_CLIENT_CARD)]: 'Карточка агента',
  [getTitleForPath(PATHS.COMPANY_AGENT_CLIENT_NEW)]: 'Создать агента',
  [getTitleForPath(PATHS.COMPANY_CLIENT_CARD)]: 'Карточка клиента',
  [getTitleForPath(PATHS.COMPANY_CLIENT_NEW)]: 'Новый клиент',
  [getTitleForPath(PATHS.SUPPORT)]: 'Клиенты компании',
  [getTitleForPath(PATHS.SUPPORT_CLIENT_CARD)]: 'Карточка клиента',
  [PATHS.ANALYTICS_MESSAGES]: 'Отчет по сообщениям',
  [getTitleForPath(PATHS.SUPPORT_ANALYTICS_MESSAGES)]: 'Отчет по сообщениям',
  [PATHS.ANALYTICS_SUMMARY_REPORT]: 'Итоговый отчет',
  [getTitleForPath(PATHS.SUPPORT_ANALYTICS_SUMMARY_REPORT)]: 'Итоговый отчет',
  [getTitleForPath(PATHS.ANALYTICS_CHANNEL)]: 'Итоговый отчет',
  [getTitleForPath(PATHS.SUPPORT_ANALYTICS_CHANNEL)]: 'Итоговый отчет',
  [PATHS.ANALYTICS_MESSAGE_MATCHERS_LIST]: 'Статистика шаблонов',
  [getTitleForPath(PATHS.ANALYTICS_MESSAGE_MATCHER)]: 'Статистика шаблонов',
  [PATHS.NOTIFICATIONS]: 'Журнал событий',
  [PATHS.HELP]: 'Помощь',
  [PATHS.TRIGGERS_NEW]: 'Новый сценарий',
  [PATHS.TRIGGERS_LIST]: 'Сценарии',
  [getTitleForPath(PATHS.SUPPORT_TRIGGERS_LIST)]: 'Сценарии',
  [getTitleForPath(PATHS.TRIGGERS_EDIT)]: 'Редактирование триггерной цепочки',
  [getTitleForPath(PATHS.TRIGGERS_VIEW)]: 'Просмотр триггерной цепочки',
  [getTitleForPath(PATHS.SUPPORT_TRIGGERS_VIEW)]: 'Просмотр триггерной цепочки',
  [PATHS.CHANNELS_PUSH_NEW]: 'Создание канала Push',
  [getTitleForPath(PATHS.CHANNELS_PUSH_APP_DATA)]: 'Данные приложения',
  [getTitleForPath(PATHS.CHANNELS_PUSH_LIST)]: 'Данные канала Push',
  [getTitleForPath(PATHS.CHANNELS_PUSH_APP_NEW)]: 'Настройка приложения {{appType}}',
  [getTitleForPath(PATHS.CHANNELS_PUSH_IOS_NEW_STEP)]: 'Настройка приложения iOS',
  [getTitleForPath(PATHS.CHANNELS_PUSH_IOS_EDIT)]: 'Настройка приложения iOS',
  [getTitleForPath(PATHS.CHANNELS_PUSH_ANDROID_NEW_STEP)]: 'Настройка приложения Android',
  [getTitleForPath(PATHS.CHANNELS_PUSH_ANDROID_EDIT)]: 'Настройка приложения Android',
  [getTitleForPath(PATHS.INTEGRATION)]: 'Интеграция',
  [getTitleForPath(PATHS.INTEGRATION_SETTINGS_API_KEY_NEW)]: 'Сгенерировать новый API-ключ',
  [getTitleForPath(PATHS.INTEGRATION_SETTINGS_CALLBACK_NEW)]: 'Новый вебхук',
  [getTitleForPath(PATHS.INTEGRATION_SETTINGS_CALLBACK_EDIT)]: 'Редактирование данных вебхука',
  [PATHS.FILES]: 'Скачивание',
  [PATHS.CORRECTIONS]: 'Корректировки',
  [PATHS.CHANNELS_VK_NOTIFY_NEW]: 'Создание канала VK Notify',
  [getTitleForPath(PATHS.CHANNELS_VK_NOTIFY_EDIT)]: 'Редактирование канала VK Notify',
  [getTitleForPath(PATHS.CHANNELS_VK_NOTIFY_VIEW)]: 'Просмотр канала VK Notify',
  [PATHS.CHANNELS_OK_NOTIFY_NEW]: 'Создание канала OK Notify',
  [getTitleForPath(PATHS.CHANNELS_OK_NOTIFY_EDIT)]: 'Редактирование канала OK Notify',
  [getTitleForPath(PATHS.CHANNELS_OK_NOTIFY_VIEW)]: 'Просмотр канала OK Notify',
  [PATHS.CHANNELS_MAX_BOT_NEW]: 'Создание канала MAX Bot',
  [getTitleForPath(PATHS.CHANNELS_MAX_BOT_EDIT)]: 'Редактирование канала MAX Bot',
  [getTitleForPath(PATHS.CHANNELS_MAX_BOT_VIEW)]: 'Просмотр канала MAX Bot',
  [PATHS.SUPPORT_INVOICE_ASSIGN]: 'Зачисление платежа',
  [PATHS.SUPPORT_INVOICE_CANCEL]: 'Отмена платежа',
  [PATHS.AGENT_PAYMENTS]: 'Платежи клиентов',
  [PATHS.AGENT_CLIENTS]: 'Мои клиенты',
  [getTitleForPath(PATHS.AGENT_CLIENT_CARD)]: 'Карточка клиента',
  [PATHS.AGENT_PROFILE]: 'Профиль компании',
  [getTitleForPath(PATHS.SUPPORT_AGENT_CLIENTS)]: 'Клиенты агента',
  [getTitleForPath(PATHS.SUPPORT_AGENT_CLIENT_CARD)]: 'Клиенты агента',
  [getTitleForPath(PATHS.SUPPORT_AGENT_PAYMENTS)]: 'Платежи клиентов агента',
  [getTitleForPath(PATHS.SUPPORT_CHANNELS_LIST)]: 'Каналы',
  [getTitleForPath(PATHS.SUPPORT_CHANNEL_VIEW)]: 'Просмотр канала',
  [PATHS.TARIFFS]: 'Каталог тарифов',
  [getTitleForPath(PATHS.TARIFF_CARD)]: 'Тариф',
  [getTitleForPath(PATHS.TARIFF_CARD_DETAIL_NEW)]: 'Добавление условия тарифа',
  [getTitleForPath(PATHS.TARIFF_CARD_DETAIL_EDIT)]: 'Редактирование условия тарифа',
  [getTitleForPath(PATHS.TARIFF_CARD_PRICING_DETAIL_NEW)]: 'Добавление тарификации',
  [getTitleForPath(PATHS.TARIFF_CARD_PRICING_DETAIL_EDIT)]: 'Редактирование тарификации',
  [getTitleForPath(PATHS.DIALOGS_MESSAGES)]: 'Диалоги',
  [PATHS.DIALOGS]: 'Диалоги',
};
